export const getChunkedListForAvailableSpace = <D>(
	list: D[],
	availableSpace: number,
	options: { rowHeight?: number; headerHeight?: number } = {}
): D[][] => {
	const headerHeight = options.headerHeight || 0;
	const rowHeight = options.rowHeight || 0.6;

	const availableSpaceWithoutHeader = availableSpace - headerHeight;
	const chunkSize = Math.floor(availableSpaceWithoutHeader / rowHeight);
	const chunks = [];
	let chunk = [];

	for (let i = 0; i < list.length; i++) {
		chunk.push(list[i]);

		if (i % chunkSize === chunkSize - 1) {
			chunks.push(chunk);
			chunk = [];
		}
	}

	if (chunk.length > 0) {
		chunks.push(chunk);
	}

	return chunks;
};

export const chunkArray = <T>(arr: T[], size: number): T[][] =>
	Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
